import React from 'react'

const GroupContext = React.createContext<boolean>(false)

export const GroupContextProvider = GroupContext.Provider

export const GroupContextConsumer = GroupContext.Consumer

export default GroupContext
